module.exports = __webpack_public_path__ + "static/media/editDriver.eeae8e4a.svg";